import { render } from "./PlanChange.vue?vue&type=template&id=238522f6"
import script from "./PlanChange.vue?vue&type=script&lang=js"
export * from "./PlanChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__